import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { NewDatePickerReact } from '../../../app/components/NewDatePickerReact';
import ProjectSelector from '../Selects/ProjectSelector';
import DictionaryMultiSelector from '../Selects/DictionaryMultiSelector';
import type { Option } from '../Selects/Selector';
import { usePokCore } from '../../../common/hooks/usePokCore';

import type { FilterYearFieldProps } from './types/FilterYearTypes';

export const FilterYearAdvancedFields: React.FC<FilterYearFieldProps> = ({
  props,
  state,
  t,
  tk,
}) => {
  const pok = usePokCore();

  return (
    <>
      {props.withMonth && (
        <FormRow controlId="month" label={t(tk.common.month)}>
          <div className="small-calendar">
            <NewDatePickerReact
              onChange={value =>
                state.setMonth(state.setDate(value as Date | undefined))
              }
              value={state.month}
              required={true}
            />
          </div>
        </FormRow>
      )}

      {props.withInvoiced && (
        <FormRow controlId="invoiced" label={t(tk.filter.hideInvoiced)}>
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={state.invoiced}
            onChange={e => state.setInvoiced(e.target.checked)}
          />
        </FormRow>
      )}

      {props.withProjects && (
        <FormRow controlId="project" label={t(tk.prLang.project)}>
          <ProjectSelector
            withChangeCompany={true}
            companyId={
              props.withoutCompany ? pok.getCompanyId() : state.companyId
            }
            onChange={option => state.setProject((option as Option)?.value)}
            value={state.project}
            clearable={true}
          />
        </FormRow>
      )}

      {props.withAttachmentsTypes && (
        <FormRow
          controlId="attachmentsTypes"
          label={t(tk.filter.attachmentsTypes)}
        >
          <DictionaryMultiSelector
            dictionary="Załączniki"
            value={state.attachmentsTypesIds}
            clearable={true}
            onChange={options =>
              state.setAttachmentsTypesIds(
                (options as Option[])?.map(({ value }) => value) || [],
              )
            }
          />
        </FormRow>
      )}

      {props.withSalesInvoices && (
        <FormRow controlId="salesInvoices" label={t(tk.filter.salesInvoices)}>
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={state.salesInvoices}
            onChange={e => state.setSalesInvoices(e.target.checked)}
          />
        </FormRow>
      )}

      {props.withSalesInvoicesCopies && (
        <FormRow
          controlId="salesInvoicesCopies"
          label={t(tk.filter.salesInvoicesCopies)}
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={state.salesInvoicesCopies}
            onChange={e => state.setSalesInvoicesCopies(e.target.checked)}
          />
        </FormRow>
      )}

      {props.withPurchaseInvoices && (
        <FormRow
          controlId="purchaseInvoices"
          label={t(tk.filter.purchaseInvoices)}
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={state.purchaseInvoices}
            onChange={e => state.setPurchaseInvoices(e.target.checked)}
          />
        </FormRow>
      )}

      {props.withContracts && (
        <FormRow controlId="contracts" label={t(tk.filter.contracts)}>
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={state.contracts}
            onChange={e => state.setContracts(e.target.checked)}
          />
        </FormRow>
      )}

      {props.withProjectAttachments && (
        <FormRow
          controlId="projectAttachments"
          label={t(tk.prLang.projectAttachments)}
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={state.projectAttachments}
            onChange={e => state.setProjectAttachments(e.target.checked)}
          />
        </FormRow>
      )}
    </>
  );
};
